<template>
  <div>
    <search-area tabName="用户列表" @search="search(1)">
      <Form
        ref="searchParam"
        :model="searchParam"
        :label-width="55"
        inline
        label-position="right"
        label-colon
      >
        <FormItem label="用户昵称" prop="nickName" :label-width="105">
          <Input
            v-model="searchParam.nickName"
            placeholder="请输入用户账号"
            style="width: 200px"
            clearable
          ></Input>
        </FormItem>
        <FormItem label="用户手机号" prop="phone" :label-width="105">
          <Input
            v-model="searchParam.phone"
            placeholder="请输入用户手机号"
            style="width: 200px"
            clearable
          ></Input>
        </FormItem>
      </Form>
    </search-area>
    <table-area
      :columns="columns"
      :data="userList"
      :total="total"
      @search="search"
      :pageNum="searchParam.currentPage"
      :pageSize="searchParam.pageSize"
    ></table-area>
    <el-dialog
      title="绑定商户"
      top="50px"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible="showBindDialog"
      @close="closeBindDialog"
    >
      <el-form ref="formData" :model="formData" :hide-required-asterisk="false">
        <el-form-item label="账号" label-width="120px">
          <el-input
            size="mini"
            disabled
            placeholder="请输入账号"
            style="width: 200px"
            v-model="formData.nickName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="所属商户" label-width="120px" prop="companyId">
          <el-select
            v-model="formData.companyId"
            placeholder="请选择"
            size="mini"
            :disabled="!isAdmin"
          >
            <el-option
              v-for="item in companyList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="showNewDialog = false">取消 </el-button>
        <el-button type="primary" size="small" @click="onSubmit"
          >确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import columns from "./account-column";
export default {
  data() {
    return {
      columns: columns(this),
      // 列表数据总数
      total: 1,
      // 加载中
      loading: false,
      // 搜索参数
      searchParam: {
        currentPage: 1,
        pageSize: 10,
        nikeName: "", // 昵称
        phone: "", // 手机号
      },
      userList: [],
      showBindDialog: false,
      formData: {},
      companyList: [],
      isAdmin: false,
    };
  },
  computed: {},
  created() {
    this.getUserList();
    this.getCompanyList();
    const userInfo = JSON.parse(
      window.localStorage.getItem("userInfo") || "{}"
    );
    this.isAdmin = userInfo.userId == "10001";
  },
  methods: {
    search(val) {
      this.searchParam.currentPage = val;
      this.getUserList();
    },
    // 查询公司列表
    async getCompanyList() {
      let data = await this.$get("/company/all");
      this.companyList = data;
    },
    async getUserList() {
      let { list, total } = await this.$post(
        "/user/listByPage",
        this.searchParam
      );
      this.userList = list || [];
      this.total = total;
    },
    closeBindDialog() {
      this.showBindDialog = false;
    },
    async onSubmit() {
      if (!this.formData.companyId) {
        this.$message.warning("请选择账户要绑定的商户");
        return;
      }
      await this.$post("/user/addOrEdit", this.formData);
      this.$message.success("操作成功");
      this.closeBindDialog();
      this.getUserList();
    },
  },
  components: {},
};
</script>

<style lang="stylus" scoped>
@import './../../styl/variables.styl'
@import './../../styl/common.styl'
.tableOut
    height: 50px;
    border: 0.1px solid #e0dede;
    background: #f1f4f512;
    span
      width: 20%;
      text-align: center;
      display: inline-block;
      float: left;
      font-size: 17px;
      border-right: 1px solid #e0dede;
      height: 50px;
      line-height: 50px;
      box-sizing: border-box;

.huiline
    padding:10px;
    border: 1px solid #e0dede;
    box-sizing: border-box;
    width: 100%;
    border-top: 0;
    background: #f1f4f512;
    font-size: 13px;
    color: #b3b0b0;

    span
     margin-left 40px
.payitem
    display: flex;
    flex-direction: column;
    text-align: left;
    box-sizing: border-box;
    padding-left: 50px;

.details
    display: flex;
    justify-content: space-around;
    font-size: 13px;
    border-bottom: 1px solid #e0dede;
    border-right: 1px solid #e0dede;

  .divspp
    width:20%;
    border-left: 1px solid #e0dede;
    padding: 10px 0;
    box-sizing:border-box;
    display: flex;
    flex-direction: column;
    align-items:center;
    text-align: left;
    box-sizing: border-box;
    justify-content: center;
.picker
    margin-left 10px

.filter-search
  display flex
  flex-wrap wrap

  .el-date-editor
    max-width 360px
    margin-right 10px
    margin-bottom 10px

  .el-input
    max-width 140px
    margin-right 10px
    margin-bottom 10px

.option-button
  position relative
  padding-right 50px

  .edit-btn
    position absolute
    right 4px

.form-upload-excel
  display inline-block
  margin-left 10px

.table-container
  margin-top 20px

  .el-pagination
    margin-top 20px

  .preview
    display flex
    justify-content center
    align-items center
    padding 10px
    margin-top 6px
    border 1px dashed #999
    border-radius 6px
  .el-dialog
    width: 500px;
.Dealing{
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  height: 100px;
}
.wildFinished{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
  .DealFinished{
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: normal;
    width: 200px;
  }
  .DealFinishedfoot{
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }
}
.direct-mail{
  color: #7600FF;
  border: 1px solid #7600FF;
  padding: 2px;
  margin-right: 2px;
  border-radius: 4px;
  font-size: 12px;
}
</style>
